module.exports = __webpack_public_path__ + "3479fec07114b6fffaf785b17d458051.png";